import { DEFAULT_MAX_CHARACTERS } from 'modules/dataDictionary/constants';
import { createRestrictionText } from 'modules/dataDictionary/utils';
import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';

export type CompountNameInputFieldProps = {
  autoFocus?: boolean;
  formFieldId?: string;
  inputId?: string;
  labelText: ReactNode;
  maxCharacters?: number;
  name: string;
};

export const ControlledInputField = ({
  autoFocus = false,
  formFieldId,
  inputId,
  labelText,
  maxCharacters = DEFAULT_MAX_CHARACTERS,
  name,
}: CompountNameInputFieldProps) => (
  <Controller
    name={name}
    render={({ field: { onChange, value = '' }, fieldState: { error } }) => {
      const restrictionText = createRestrictionText(value.length, maxCharacters);
      return (
        <FormField
          data-test={formFieldId}
          errorText={error?.message}
          hasError={Boolean(error?.message)}
          labelText={labelText}
          restrictionText={restrictionText}
        >
          <InputText autoFocus={autoFocus} data-test={inputId} onChange={onChange} value={value} />
        </FormField>
      );
    }}
  />
);
